import React, { useState, useEffect } from 'react'
import axios from 'axios'
import RenderTexto from './textos.js'

import Cabecalho from '../CabecalhoView/Cabecalho'
import '../DespachoView/DespachoView.css'

const DespachoNovoView = () => {
    const [dados, setDados] = useState({})

    useEffect(() => {
        const id = window.location.pathname.slice(18)
        const pafId = window.location.search.slice(1)
        const url = `/api/despacho/getDespachoNovo/${id}`
        axios.post(url, { pafId })
            .then(res => {
                setDados({...res.data.despacho, processo: res.data.numeroPaf})
            })
            .catch(error => {
                console.log(error)
                alert(error.response)
            })
    }, [])
    return (
        <>
            <Cabecalho estado={dados.estado} />
            <h2 className="mt-4">Despacho</h2>
            <div className="topo">
                <div>Processo nº {dados.processo}</div>
                <div>Fiscalizado: {dados.fiscalizado}</div>
                <div>Responsável Técnico: {dados.responsavel}</div>
            </div>
            <div>
                {RenderTextos()}
            </div>
            <div className="identificacao">
                <p>{dados.user}</p>
                {RenderFuncao()}
            </div>
        </>
    )

    function RenderTextos() {
        let textos = []
        if (dados.despachos) {
            dados.despachos.map(el => textos.push(RenderTexto(el)))
        }
        return textos
    }

    function RenderFuncao() {
        const profissao = dados.fonte
        if(profissao == "coordenacao") {
            return (
                <p>Coordenação Geral do DEFIS</p>
            )
        }
        else if(profissao == "coordenacao_pb") {
            return (
                <p>Coordenação Geral</p>
            )
        }
        else if(profissao == "defis") {
            return (
                <p>Membro DEFIS - Coordenação {dados.estado}</p>
            )
        }
        else if(profissao == "administrativo") {
            return (
                <p>Assistente Administrativo</p>
            )
        }
        else if(profissao == "presidencia") {
            return (
                <p>Presidência</p>
            )
        }
        else if(profissao == "vice-presidencia") {
            return (
                <p>Vice-Presidência</p>
            )
        }
        else if(profissao == "fiscal" || profissao == "fiscalAssessor") {
            return (
                <p>Fiscal</p>
            )
        }
        else if(profissao == "juridico") {
            return (
                <p>Assessoria Jurídica</p>
            )
        }
    }
}

export default DespachoNovoView